// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBar-cls1_F7X","cls2":"SearchBar-cls2_lL6 SearchBar-cls1_F7X"};